@if ((tableColumns() | misc: "customTableColumsFilterExists")?.length) {
  <gtapp-data-filter
    [tableColumnsInput]="tableColumns()"
    (updateParent)="onUpdateParent($event)"
  >
  </gtapp-data-filter>
}

@if (
  tableCustomParams()?.paginationData &&
  rows >= 10 &&
  totalRows > rows &&
  showTopPaginator
) {
  <div class="mt-2">
    <gtapp-pagination-control
      [pageSize]="rows"
      [pageNum]="pageNum"
      [previous]="previousRows"
      [totalRows]="totalRows"
      [fixedRows]="tableCustomParams()?.paginationData?.fixedRows"
      (onChangePagination)="onChangePagination($event)"
    >
    </gtapp-pagination-control>
  </div>
}
<div [ngStyle]="tableStyle" class="mt-6 pe-3" style="scrollbar-gutter: stable">
  <table class="table table-desktop" id="gt-table">
    <thead [ngClass]="tableCustomParams()?.hideHeaders ? 'd-none' : ''">
      <tr>
        @if (tableCustomParams()?.checkBoxSelectionEnabled) {
          <th></th>
        }
        @if (!tableCustomParams()?.hideHeaders) {
          @for (
            indColumn of tableColumns();
            track trackByColumn($index, indColumn)
          ) {
            <th [ngStyle]="indColumn?.tableHeaderStyle">
              <div class="d-flex justify-content-between align-items-center">
                <span>{{ indColumn?.header }} </span>

                @if (totalRows > 1 || desktopTableDataTemp().length > 1) {
                  <ng-container
                    *ngTemplateOutlet="
                      headerActions;
                      context: { $implicit: indColumn, col: indColumn }
                    "
                  ></ng-container>
                }
              </div>
              @if (indColumn?.openSearchBox) {
                <gtapp-data-filter
                  [tableColumnsInput]="tableColumns()"
                  [indColumnInput]="indColumn"
                  (updateParent)="onUpdateParent($event)"
                >
                </gtapp-data-filter>
              }
              @if (indColumn?.opendropDownBox) {
                <gtapp-data-filter
                  [tableColumnsInput]="tableColumns()"
                  [indColumnInput]="indColumn"
                  (updateParent)="onUpdateParent($event)"
                >
                </gtapp-data-filter>
              }
            </th>
          }
        }
      </tr>
    </thead>
    <tbody class="table-group-divider align-middle">
      @for (row of tableData(); track trackByRow($index, row); let i = $index) {
        <tr
          role="button"
          [ngStyle]="
            tableCustomParams()?.tableRowStyle
              ? tableCustomParams()?.tableRowStyle(row)
              : {}
          "
          (click)="onTableRowClick(row, i)"
          [class.selected]="i === selectedIndex"
        >
          @if (tableCustomParams()?.checkBoxSelectionEnabled) {
            <td (click)="$event.stopImmediatePropagation()">
              <input
                class="form-check-input"
                type="checkbox"
                [checked]="row?.checboxTicked"
                (change)="onCheckBoxChange($event, row)"
              />
            </td>
          }
          @for (
            col of tableColumns();
            track trackByColumn($index, col);
            let j = $index
          ) {
            <td
              [ngStyle]="
                col?.conditionalColumnStyle
                  ? col?.conditionalColumnStyle(row)
                  : col?.tableColumnStyle
              "
            >
              <ng-container
                *ngTemplateOutlet="
                  cellRenderer;
                  context: { $implicit: col, row: row, index: i }
                "
              ></ng-container>
            </td>
          }
        </tr>
      }
    </tbody>
  </table>
</div>
@if (tableData().length == 0) {
  <div>
    <div class="alert" role="alert">No Records Found</div>
  </div>
}
@if (tableCustomParams()?.paginationData) {
  <div class="mt-2" id="bottom-paginator">
    <gtapp-pagination-control
      [pageSize]="rows"
      [pageNum]="pageNum"
      [previous]="previousRows"
      [totalRows]="totalRows"
      [fixedRows]="tableCustomParams()?.paginationData?.fixedRows"
      (onChangePagination)="onChangePagination($event)"
    >
    </gtapp-pagination-control>
  </div>
}
<!--header template-->
<ng-template #headerActions let-col>
  <div class="d-flex flex-row gap-2">
    @if (!col?.openSearchBox && col?.toggleFields && apiFiltering()) {
      <span (click)="toggleField(col)">
        <i class="fa-solid fa-left-right"></i>
      </span>
    }
    @if (!col?.openSearchBox && col?.sortKey) {
      <span (click)="sortField(col)">
        <i
          class="fa-solid"
          [ngClass]="
            col?.sortOrder === 'desc'
              ? 'fa-arrow-down-z-a'
              : 'fa-arrow-down-a-z'
          "
        ></i>
      </span>
    }
    @if (!col?.openSearchBox && col?.searchKey) {
      <span (click)="col.openSearchBox = true">
        <i class="fa-solid fa-filter"></i>
      </span>
    }
    @if (col?.openSearchBox || col?.opendropDownBox) {
      <span (click)="col.openSearchBox = false; col.opendropDownBox = false">
        <i class="fa fa-close"></i>
      </span>
    }
    @if (!col?.opendropDownBox && col?.dropdownKey) {
      <span
        (click)="
          col?.multipleSelect
            ? openMultipleSelect(col, multiSelectDialog)
            : (col.opendropDownBox = true)
        "
      >
        <i class="fa-regular fa-rectangle-list"></i>
      </span>
    }
    @if (col?.dateRangeKey) {
      <span (click)="openRangePicker(col)">
        <i class="fa fa-calendar"></i>
      </span>
    }
  </div>
</ng-template>

<!--prefix template-->

<ng-template #prefix let-col let-row="row">
  <span
    [ngStyle]="
      col?.conditionalPrefixStyle
        ? col?.conditionalPrefixStyle(row)
        : col?.prefixStyle
    "
  >
    {{
      col?.prefixNestedValue ? col?.prefixNestedValue(row) : col?.prefix || ""
    }}
  </span>
</ng-template>
<!--suffix template-->
<ng-template #suffix let-col let-row="row">
  <span
    [ngStyle]="
      col?.conditionalSuffixStyle
        ? col?.conditionalSuffixStyle(row)
        : col?.suffixStyle
    "
  >
    {{
      col?.suffixNestedValue ? col?.suffixNestedValue(row) : col?.suffix || ""
    }}
  </span>
</ng-template>

<!--2nd suffix template-->
<ng-template #suffix2 let-col let-row="row">
  <span
    [ngStyle]="
      col?.conditionalSuffix2Style
        ? col?.conditionalSuffix2Style(row)
        : col?.suffix2Style
    "
  >
    {{
      col?.suffix2NestedValue
        ? col?.suffix2NestedValue(row)
        : col?.suffix2 || ""
    }}
  </span>
</ng-template>

<ng-template #cellRenderer let-col let-row="row" let-i="index">
  <!-- Prefix -->
  <ng-container
    *ngTemplateOutlet="prefix; context: { $implicit: col, row: row }"
  ></ng-container>

  <!-- DATETIME -->
  @if (col?.datetimeObj) {
    <span
      [ngStyle]="
        col?.conditionalColumnDataStyle
          ? col?.conditionalColumnDataStyle(row)
          : col?.columnDataStyle
      "
    >
      {{
        (col?.nestedValue ? col?.nestedValue(row) : row?.[col?.name])
          | customDate: col?.dateTimeFormat || "d MMM y HH:mm"
      }}
    </span>
  } @else if (col?.iconObj) {
    <span
      [ngStyle]="
        col?.conditionalColumnDataStyle
          ? col?.conditionalColumnDataStyle(row)
          : col?.columnDataStyle
      "
    >
      <i
        [class]="
          col.iconClass
            ? col?.iconClass
            : col?.nestedValue
              ? col?.nestedValue(row)
              : row?.[col?.name]
        "
        [title]="
          col.iconTitle
            ? col?.iconTitle
            : col?.nestedValue
              ? col?.nestedValue(row)
              : row?.[col?.name]
        "
      ></i>
    </span>
  }

  <!-- IMAGE -->
  @else if (col?.imageObj) {
    @if (col?.mediaSrc || col?.nestedValue?.(row) || row?.[col?.name]) {
      <img
        [ngStyle]="
          col?.conditionalImageStyle
            ? col?.conditionalImageStyle(row)
            : col?.imageStyle
        "
        [src]="
          col?.mediaSrc
            ? col?.mediaSrc
            : col?.nestedValue
              ? col?.nestedValue(row)
              : row?.[col?.name]
        "
      />
    }
  } @else if (col?.showAction) {
    <ng-container
      *ngTemplateOutlet="
        actionOptions;
        context: { $implicit: col, row: row, index: i }
      "
    ></ng-container>
  }
  <!-- DEFAULT -->
  @else {
    <span
      class="gt-multi-line"
      [ngStyle]="
        col?.conditionalColumnDataStyle
          ? col?.conditionalColumnDataStyle(row)
          : col?.columnDataStyle
      "
    >
      {{
        col?.nestedValue
          ? col?.nestedValue(row)
          : row?.[col?.name] === "null" || row?.[col?.name] === "undefined"
            ? "N/A"
            : row?.[col?.name]
      }}
    </span>
  }

  <!-- Suffix -->
  <ng-container
    *ngTemplateOutlet="suffix; context: { $implicit: col, row: row }"
  ></ng-container>
  <!-- Suffix 2 -->
  <ng-container
    *ngTemplateOutlet="suffix2; context: { $implicit: col, row: row }"
  ></ng-container>
</ng-template>

<ng-template #actionOptions let-col let-row="row" let-index="index">
  @for (action of col?.actionOptions; track trackByAction($index, action)) {
    @if (action?.condition ? action?.condition(row) : true) {
      <span
        [ngStyle]="
          action?.conditionalActionStyle
            ? action?.conditionalActionStyle(row)
            : action?.actionStyle
        "
        [attr.role]="action?.condition(row)?.role || action?.role"
        [attr.title]="action?.condition(row)?.title"
        class="mx-1"
        (click)="
          onActionClick(row, action?.condition(row)?.type, index);
          $event.stopImmediatePropagation()
        "
      >
        @if (action?.condition(row)?.prefix) {
          <span
            [ngStyle]="
              action?.condition(row)?.conditionalPrefixStyle
                ? action?.condition(row)?.conditionalPrefixStyle(row)
                : action?.condition(row)?.prefixStyle
            "
          >
            {{ action?.condition(row)?.prefix }}
          </span>
        }
        @if (action?.condition(row)?.icon) {
          <span>
            <i
              [class]="action?.condition(row)?.icon"
              [attr.title]="action?.condition(row)?.title"
            ></i>
          </span>
        }
        @if (action?.condition(row)?.value) {
          <span
            [ngStyle]="
              action?.condition(row)?.conditionalValueStyle
                ? action?.condition(row)?.conditionalValueStyle(row)
                : action?.condition(row)?.valueStyle
            "
            [ngClass]="
              action?.condition(row)?.conditionalValueClass
                ? action?.condition(row)?.conditionalValueClass(row)
                : action?.condition(row)?.valueClass
            "
          >
            {{ action?.condition(row)?.value }}
          </span>
        }
      </span>
    }
  }
</ng-template>

<ng-template #multiSelectDialog let-data let-multiSelectDialogRef="dialogRef">
  <div class="dialog-box card p-2">
    <div class="card-header">
      <span class="float-end" (click)="multiSelectDialogRef.close()">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>
    <div class="p-3">
      <gtapp-data-filter
        [tableColumnsInput]="tableColumns()"
        [indColumnInput]="data"
      >
      </gtapp-data-filter>
    </div>

    <div class="pt-4 d-flex gap-2">
      <button
        type="button"
        class="btn btn-dark w-100 btn-md"
        (click)="multiSelectDialogRef.close()"
      >
        Cancel
      </button>

      <button
        type="button"
        class="btn btn-primary w-100 btn-md"
        [disabled]="!data?.selectedItems?.length"
        (click)="multiSelectDialogRef.close(true)"
      >
        Apply
      </button>
    </div>
  </div>
</ng-template>
